import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getUOMCONVERSIONTableStructure";
export const UPDATE_TABLE_DATA = "getUOMCONVERSIONTableData";
export const EXPORT_TABLE_DATA = "exportUOMCONVERSIONTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setUOMCONVERSIONTableStructure";
export const SET_TABLE_DATA = "setUOMCONVERSIONTableData";
export const SET_TABLE_FILTER = "setUOMCONVERSIONTableFilter";
export const SET_TABLE_PAGE = "setUOMCONVERSIONTablePage";
export const SET_TABLE_PERPAGE = "setUOMCONVERSIONTablePerPage";
export const SET_TABLE_SORTBY = "setUOMCONVERSIONTableSortBy";
export const SET_TABLE_SORTORDER = "setUOMCONVERSIONTableSortOrder";
export const SET_EXPORT_LINK = "setUOMCONVERSIONExportLink";
export const SET_ACTIONS_DIALOG_SERVER_DATA =
  "setUOMCONVERSIONActionsDialogServerData";
export const UPDATE_ACTIONS_DIALOG_SERVER_DATA = "getUOMCONVERSIONCreateData";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  actionsDialogServerData: null,
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  /**
   * for table title, description
   * */
  getUOMCONVERSIONTableProperties(state) {
    return state.table_structure.properties;
  },
  /**
   * for table permissions
   **/
  getUOMCONVERSIONTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getUOMCONVERSIONTableState(state) {
    return state.table_state;
  },

  getUOMCONVERSIONTableHeaders(state) {
    return state.table_structure.columns;
  },

  getUOMCONVERSIONTableFilters(state) {
    return state.table_structure.filters;
  },

  getUOMCONVERSIONTableData(state) {
    return state.table_data.data;
  },

  getUOMCONVERSIONExportUrl(state) {
    return state.export_link;
  },
  getUOMCONVERSIONActionsDialogServerData(state) {
    return state.actionsDialogServerData;
  },
  getUOMCONVERSIONUploadType(state) {
    return state.table_structure.type;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    // console.log(payload);
    return new Promise((resolve) => {
      ApiService.post("/warehouse_management/custom/uom_conversions")
        .then(({ data }) => {
          // console.log("suc", data);
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      // ApiService.post("login", credentials)
      ApiService.post(
        "/warehouse_management/custom/uom_conversions/datatable",
        payload
      )
        .then(({ data }) => {
          // console.log("data of datatable ", data);
          context.commit(SET_TABLE_DATA, data);
          resolve(data);
          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/warehouse_management/custom/uom_conversions/export",
        payload
      )
        .then(({ data }) => {
          // console.log("export data is ", data);
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_ACTIONS_DIALOG_SERVER_DATA](context) {
    return new Promise((resolve) => {
      ApiService.post("/warehouse_management/custom/uom_conversions/create")
        .then(({ data }) => {
          context.commit(SET_ACTIONS_DIALOG_SERVER_DATA, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_ACTIONS_DIALOG_SERVER_DATA](state, actionsDialogServerData) {
    state.actionsDialogServerData = actionsDialogServerData;
  },
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
